import React from 'react';

import './footer.css';


export default function Footer() {
    return (
        <footer>
            <span>ShoppingCart V2 By : Bruno Fay</span>
            <span> Made in 2022</span>
        </footer>
    )

}
